import { Injectable, inject } from '@angular/core';
import { SentryService } from './sentry.service';
import { normalizeError } from 'src/app/common/errors/error-utilities';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private sentryService = inject(SentryService);

  public signIn(userId: string, operatorId: string): void {
    this.sentryService.setUserId(userId);
    this.sentryService.setOperator(operatorId);
  }

  public logBreadcrumb(name: string, params: object = {}): void {
    this.sentryService.addBreadcrumb(name, params);
  }

  public async handleError<T extends Record<string, unknown>>(
    err: unknown,
    context?: string,
    data?: T,
  ): Promise<void> {
    // Convert into an Error
    const error = normalizeError(err);

    // Capture the exception with Sentry
    this.sentryService.captureException(error, context, data);

    console.error(error.message);
  }
}
